import React from 'react';
import { Route } from 'react-router-dom';

export const NARCRoute = ({exact, path, component: Component}) => (
    <Route exact={exact} path={path} render={(props) => (
      <div>
        <Component {...props}/>
      </div>
    )}/>
);